module.exports = __webpack_public_path__ + "img/icon_ing2.c57ec6a.png";